export default __webpack_public_path__ + "static/media/room_4.5f53e4e3.png";